import { ArrowRight, CheckCircle, MapPin } from 'lucide-react';
import { Button } from './ui/button';
import { mockData } from '../mock';

export const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const features = [
    'Established 2024',
    'Licensed & Insured',
    'Quality Guaranteed'
  ];

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img 
          src={mockData.company.coverPhoto} 
          alt="A to Z Home Solutions Cover" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/40"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
        <div className="space-y-8 animate-fade-in">
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white leading-tight">
            Your Dream Home,
            <br />
            <span className="bg-gradient-to-r from-orange-400 to-orange-600 bg-clip-text text-transparent">
              Built to Perfection
            </span>
          </h1>
          
          <p className="text-xl sm:text-2xl text-gray-200 max-w-3xl mx-auto">
            From interior design to complete construction - we bring your vision to life with excellence and expertise.
          </p>

          {/* Service Locations */}
          <div className="flex flex-wrap justify-center gap-4 mt-8">
            <div className="flex items-center gap-2 bg-white/90 backdrop-blur-sm px-5 py-3 rounded-full shadow-lg">
              <MapPin className="text-orange-600" size={22} />
              <span className="text-gray-800 font-semibold">
                Serving: {mockData.company.serviceLocations.join(' • ')}
              </span>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-4 mt-6">
            {features.map((feature, index) => (
              <div
                key={index}
                className="flex items-center gap-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full shadow-md"
              >
                <CheckCircle className="text-orange-600" size={20} />
                <span className="text-gray-800 font-medium">{feature}</span>
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12">
            <Button
              onClick={() => scrollToSection('contact')}
              size="lg"
              className="bg-orange-600 hover:bg-orange-700 text-white text-lg px-10 py-7 transition-all duration-200 hover:scale-105 shadow-2xl font-bold"
            >
              Contact Us Now
              <ArrowRight className="ml-2" size={22} />
            </Button>
            <Button
              onClick={() => scrollToSection('projects')}
              size="lg"
              variant="outline"
              className="border-2 border-white bg-white/90 text-orange-600 hover:bg-white text-lg px-10 py-7 transition-all duration-200 hover:scale-105 shadow-xl font-bold"
            >
              View Our Work
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};